import styled from 'styled-components';

export const SpinnerBase = styled.svg`
    animation: rotate 2s linear infinite;

    circle {
        stroke-linecap: round;
        animation: dash 1.5s ease-in-out infinite;
    }

    @keyframes rotate {
        100% {
            transform: rotate(360deg);
        }
    }

    @keyframes dash {
        0% {
            stroke-dasharray: 1, 150;
            stroke-dashoffset: 0;
        }
        50% {
            stroke-dasharray: 90, 150;
            stroke-dashoffset: -35;
        }
        100% {
            stroke-dasharray: 90, 150;
            stroke-dashoffset: -124;
        }
    }
`;

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const SpinnerFullscreenBase = styled(SpinnerBase)`
    z-index: 2;
    position: absolute;
    top: 50%;
    left: 50%;
    margin: -50% 0 0 -50%;
`;
